export interface IChipItem {
    id: string;
    text: string;
    count?: number;
    imageUrl?: string;
    disabled?: boolean;
}

export enum Operator {
    Or = "or",
    And = "and",
}

export interface IMultiChipDownProps {
    options: IChipItem[];
    /** The ID of an option */
    initialSelectedItems?: { [key: string]: boolean } | {};
    buttonText: string;
    onDone: (selectedItems: IChipItem[]) => void;
    trackingOnApply?: (selectedItems: IChipItem[]) => void;
    hasSearch?: boolean;
    searchPlaceHolder?: string;
    searchFilter?: (term: string, item: IChipItem) => boolean;
    onSearch?: (term: string) => void;
    getDropdownItem?: any;
    dropdownWidth?: number;
    dropdownPopupHeight?: number;
    isDisabled?: boolean;
    virtualize?: { itemBuffer: number };
    maxVirtualItemsToRender?: number;
    clearSelectionWhenOneOption?: boolean;
    appendTo?: null | string;
    labelFooterButton?: string;
    chipTooltip?: string;
    renderChipTitleText?: (selectedItems: string[], setChipTitle: (title: string) => void) => void;
    onToggleDropdown?: (isOpen: boolean) => void;
    titleOperator?: Operator;
    onSelectItem?: (selectedItem: IChipItem) => void;
    headerComponent?: React.ReactNode;
    selectedText?: string;
    shouldDisableApplyButton?: (selectedItems: IChipItem[]) => boolean;
    onItemClick?: (selectedItem: FixmeType, selectedItems: FixmeType) => void;
    cssClassContainer?: string;
    getNoResultsComponent?: () => React.ReactNode;
    showTooltip?: boolean;
}
